import { TooltipPrimeReact } from "@finanedi.es/storybook"
import { useEffect, useRef, useState } from "react"

const TextWithTooltip = ({ id, text }: { id?: string; text?: string }) => {
  const textRef = useRef<HTMLParagraphElement>(null)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    if (textRef.current) {
      const isTruncated =
        textRef.current.scrollWidth > textRef.current.clientWidth
      setShowTooltip(isTruncated)
    }
  }, [text])

  return (
    <div className={showTooltip ? `documentoTooltip-${id}` : ""}>
      <p
        ref={textRef}
        className='!tw-text-sm tw-text-ellipsis tw-truncate'
      >
        {text ?? "-"}
      </p>
      {showTooltip && (
        <TooltipPrimeReact
          id={`documentoTooltip-${id}`}
          target={`.documentoTooltip-${id}`}
          position='left'
        >
          <p className='!tw-text-sm'>{text}</p>
        </TooltipPrimeReact>
      )}
    </div>
  )
}
export default TextWithTooltip
